(ns com.theplantscape.plant-web.pages.polyculture.events
  (:require
   [cljs.core.async :refer [<! go]]
   [com.theplantscape.calculate.ensemble
    :refer [extend-line line-circle-intersection snap-closest-radius]]
   [com.theplantscape.local-store.diagram-db :refer [fetch-plant]]
   [com.theplantscape.local-store.ensemble
    :refer [insert-plant-data insert-polyculture-data plant-exists? rm-entity]]
   [com.theplantscape.plant-web.api.plants :refer [fetch-plant-async]]
   [com.theplantscape.plant-web.draw.events
    :as evt
    :refer [move-ob select-ob-from-point]]
   [com.theplantscape.plant-web.draw.state
    :refer
    [app-state hide-modal reset-mouse set-mode site-state]]))

(defn polyculture-global-keys [key]
  (when (-> @site-state :global-events)
    (case key
      "Space" (prn "space") #_(m/select-plant-modal)
      ;; " " (m/select-plant-modal)
      ;; "d" (toggle-debug)
      "s" (set-mode :select nil)
      "m" (set-mode :move nil)
      "r" (set-mode :remove nil)
      "Escape" (do (reset-mouse) (hide-modal))
      "Delete" (rm-entity (-> @app-state :selected :eid))
      ;; "ArrowUp" (pan-canvas 0 1)
      ;; "ArrowDown" (pan-canvas 0 -1)
      ;; "ArrowLeft" (pan-canvas 1 0)
      ;; "ArrowRight" (pan-canvas -1 0)
      nil)))

(defn snap-grid [circles pos]
  (let [center 0
        radius (snap-closest-radius
                [center center]
                pos circles)]
    (first (line-circle-intersection [center center]
                                     (second
                                      (extend-line
                                       [center center]
                                       pos 200))
                                     [center center] radius))))

(defn add-plant->db [plant-entity-id]
  (when-not (plant-exists? plant-entity-id)
    (go (let [[result plant]  (<! (fetch-plant-async plant-entity-id))]
          (when result
            (insert-plant-data
             {:plant/plant-entity-id (-> plant :plant :xt/id)
              :plant/common-name (-> plant :plant :plant/common-name)
              :plant/scientific-name (-> plant :plant :plant/scientific-name)
              :plant/type (-> plant :plant :plant/type)}))))))

(defn add-plant->polyculture
  [circles pos]
  (prn "add plant to polyculture")
  (let [plant (fetch-plant (-> @app-state :current :plant :db/id))]
    (insert-polyculture-data
     {:polyculture.plant/points [(vec pos)]
      :polyculture.plant/plant-entity-id (-> plant :db/id)
      :polyculture.plant/name (-> plant :plant/common-name)
      :polyculture.plant/polyculture 37})))

(defn action [circles action-type pos]
  (let [points (snap-grid circles pos)]
    (case action-type
      :update (move-ob :polyculture.plant/points points)
      (case (:mode @app-state)
        :move (move-ob :polyculture.plant/points points)
        :select (select-ob-from-point :polyculture.plant/points points)
        ;;:remove (select-remove-ob xy)
        :insert (add-plant->polyculture circles points)
        (select-ob-from-point :polyculture.plant/points points)))))

(comment (set-mode :move))
